import { ExamCourseLanguage, ExamCourseType } from '@exam-center/graphql';
import { Alert } from '@shared/components';

import { useExamCourse } from '../../providers';

export default function ExamCourseSettingsAlert() {
  const { examCourse } = useExamCourse();

  if (!examCourse) {
    return null;
  }

  if (examCourse.type !== ExamCourseType.Mock || examCourse.language !== ExamCourseLanguage.En) {
    return null;
  }

  return <Alert severity='warning'>หลักสูตรประเภทนี้ไม่มี Certificate Template ให้เลือก</Alert>;
}
